<template>
  <k-editor-form>
    <template #left>
    	<k-layout v-if="active">
        <k-flex c5>
          <vod-editor :uuid="id" :use-save-dialog="true" disable-key-events></vod-editor>
        </k-flex>
        <k-flex c7>
          <clips :uuid="id"></clips>
        </k-flex>
      </k-layout>
    </template>
  </k-editor-form>
</template>

<script>
import Clips from '@/components/cloudrec/Clips.vue'
import VodEditor from '@/components/cloudrec/Vod.vue'

export default {
	props: ["id"],
  components: {
    Clips,
    VodEditor
  },
  data () {
    return {
      active: this.$route.query.tab == "clips"
    }
  },
  watch: {
    "$route.query.tab" (newVal) {
      if(newVal == "clips") {
        setTimeout(() => {
          this.active = true;
        },200);
      }
    }
  }
}
</script>
